import React from "react"
import { useAppContainerContext } from "../appContainer/context"
import { useUserContext } from "../contextProviders/userContext"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"

import { ReportTableV2 } from "../reportTableV2"
import { CLI_V2, REP_TPL } from "../../../shared/Data/typeDirs"
// import { makeAdmin } from "../../../services/networkRequests"
import { deduplicateReportPhotosInBlocks } from "../../../services/networkRequests"
// import { clearNewReportTables, makeAdmin } from "../../../services/networkRequests"

export function PageHomeDisplay() {
  const { user, logout } = useUserContext()
  const { setMenuOptions, setTitle } = useAppContainerContext()
  const navigate = useNavigate()

  useEffect(() => {
    // console.log('what is hist', history) 
    let timeout_id = setTimeout(() => {
      // let menuOptions = user.role === 'admin' ? [{name: 'Admin Page', callback: () => navigate('/admin') }] : []
      
      setMenuOptions([
        // ...menuOptions,
        { name: 'Utilities', callback: () => navigate('/utils') },
        { name: 'Clients', callback: () => navigate(`/${CLI_V2}`) },
        { name: 'Templates', callback: () => navigate(`/${REP_TPL}`) },
        // { name: 'Logout', callback: () => logout() },
        // { name: 'create default user', callback: () => makeAdmin(user.token) },
        // {name: 'Init Lang Entries as PNA or O&M', callback:()=> addTagsToLanguageEntries() },
        // {name:'Import CASp stuff', callback: ()=>importNewLanguageEntriesFromXLS(`C:\\Users\\Eric\\Downloads\\_CASp Language 08162024 new.xlsx`)},
        // {name:'clear new rep tables', callback:async ()=> clearNewReportTables(user.token)},
        // {name: 'Create default Report_v2', callback: async ()=>{
        //   let res = await createAndAddDefaultReport(user.token)
        //   // let res = await dataSource('remDb')[REP_V2].get({name: 'Default Test Report'})
        //   console.log('got a new report maybe? ', res)
        // }},
        // {name:'get new report', callback: async ()=>{
        //   let res = await dataSource('remDb')[REP_V2].get({name: 'Default Test Report'})
        //   console.log('got a new report maybe? ', res)
        // } },
        // {name:"dbg test", callback: async ()=>{
        //   let res = await getCollectionList(user.token)
        //   console.log('tested dbg', res)
        // }},
        // {name:"dTEST", callback:()=>history.push('/dtest')},
        // {name: 'copy Clark Residence V2 previews to archive', callback: async ()=>{
        //   let filesToCopy = await getFullDropboxDirListing('/MetaStoryFiles/report_markers/Clark Residence V2-02-15-2024-142217/photos_sm')
        //   // await createDropboxFolder('/Archive/report_markers/Clark Residence V2-02-15-2024-142217/photos')
        //   console.log('paths', filesToCopy)
        //   while ( filesToCopy.length) {

        //     let bin = filesToCopy.splice(0, 50).map(itm=>{
        //       let fileName = itm.split('/')[itm.split('/').length-1].split('_')[0]
        //       return {
        //         from_path:itm,
        //         to_path:`/Archive/report_markers/Clark Residence V2-02-15-2024-142217/photos/${fileName}.jpg`
        //       }
        //     })
        //     console.log('attempt to copy this', bin)
        //     await copyBatch(bin)

        //   }
        // }}
      ])
      setTitle('Home')
    })
    return () => {
      clearTimeout(timeout_id)
    }
  }, [setMenuOptions, navigate, logout, setTitle, user.role])

  function handleReportClick(report) {
    navigate(`/reports/${report._id}`)
  }

  function handleClientClick(client) {
    navigate(`/clients/${client._id}`)
  }

  return (
    <div className="content-wrapper">
      <ReportTableV2 />
    </div>
  )
}
